module.exports = __webpack_public_path__ + "static/media/InterpretingSpreadsSevenCards.e79a4c6d.jpg";